import { type RefObject } from 'react'
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

export function useObservedLayoutMeasure(options: {
    containerRef: RefObject<HTMLElement>
    contentRef?: RefObject<HTMLElement>
    depKey?: string | number | boolean | null | object
    enabled: boolean
    measure: () => void
}): void {
    const { containerRef, contentRef, depKey, enabled, measure } = options

    useIsomorphicLayoutEffect(() => {
        if (!enabled) return

        measure()

        const container = containerRef.current
        if (!container) return

        const observer = new ResizeObserver(() => {
            measure()
        })
        observer.observe(container)

        const content = contentRef?.current
        if (content) {
            observer.observe(content)
        }

        return () => observer.disconnect()
    }, [containerRef, contentRef, depKey, enabled, measure])
}
